import { render } from "./ico-arrow-down.vue?vue&type=template&id=5e153822&ts=true"
import script from "./ico-arrow-down.vue?vue&type=script&lang=ts"
export * from "./ico-arrow-down.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__